export const circuitModelMixin = {
  data() {
    return {
      circuitModelObj: {
        org_id: null,
        trainer_id: '0',
        user_id: '0',
        label: '',
        description: null,
        restInterval: null,
        circuitReps: 1,
        trainerFeedback: {
          intro: {
            text: null,
          },
          outro: {
            text: null,
          },
        },
        exercises: [],
      },
      circuitExerciseSetModelObj: {
        reps: 1,
        afterSetRest: 0,
        time: 0,
        weight: 0,
      },
    };
  },
  methods: {
    getCircuitModel() {
      return this.circuitModelObj;
    },
    getCircuitExerciseSetModel() {
      return this.circuitExerciseSetModelObj;
    },
  },
};
